import React from "react";
import { langLabel } from "../_helpers/language";
import { connect } from "react-redux";
import { userService } from "../_services";
import { vcardService } from "../_services/vcard.service";
import { anketaService } from "../_services/anketa.service";
import { serverUrl } from "../_constants";
import { userActions, appActions } from "../_actions";
import DropFile from "../_components/DropFile";
import { Snack } from "../_components";
import UserInfoDialog from "../ClientPages/UserInfoDialog";

import "../css/style.css";

import i18next from "i18next";
import RefillBalance from "./Settings/RefillBalance";
import Requisites from "./Settings/Requisites";
import { Button } from "@material-ui/core";
import { Select, MenuItem, Checkbox, FormControlLabel } from "@mui/material";
import LabelHint from "../_components/LabelHint";
import { showGlobalSnackbar } from "../_services/snackbarService";
import { responseErrorToText } from "../_helpers/error";

class SettingsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      activeTab: 0,
      req_list: [],
      req_data: [],
      req_keys: [],
      tariff_id: 0,
      tariff_name: "",
      tariff_actions: null,
      tariff_expire: null,
      balance: "0",
      add_money: "0",
      anketaFields: [],
      anketaValues: {},
      vcardQr: null,
      vcard: null,
      // Согласие на рассылку бэк хранит меткой времени, в UI это галочка.
      // Держим отдельным состоянием, чтобы переключаться сразу, не дожидаясь
      // ответа, и откатываться при ошибке.
      newsConsent: !!props.user.info.news_consent,
      showInfoDialog: false,
      snackShow: false,
      avatarUploading: false,
      snackText: i18next.t("changes_saved"),
      timezones: {},
    };
  }

  componentDidMount() {
    // Программный переход на конкретную вкладку (ссылка «Пополните баланс» из
    // ограничений мероприятия). Сбрасываем всегда: у не-орга вкладки 1–3 нет,
    // и зависшее значение открыло бы их при следующем входе в настройки.
    const { app, dispatch } = this.props;
    if (app.settingsTab != null) {
      if (this.props.user.info.type === "org") {
        this.setState({ activeTab: app.settingsTab });
      }
      dispatch(appActions.setSettingsTab(null));
    }
    if (this.props.user.info.type !== "student") {
      this.getTarifInfo();
    }
    this.getUserInfo();
    this.getAnketaFields();
    this.getTimezones();
    this.getVcardQr();
  }

  getVcardQr = () => {
    vcardService.getVcardQr(
      (data) => {
        this.setState({ vcardQr: data.qr, vcard: data.vcard });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  downloadVcf = () => {
    vcardService.downloadVcf(this.state.vcard);
  };

  getTimezones = () => {
    const self = this;
    userService.getWrapper(
      "api/timezone",
      (data) => {
        self.setState({ timezones: data.data });
      },
      (error) => {
        self.props.dispatch(userActions.set_error(error));
        console.log(error);
      }
    );
  };

  getAnketaFields = () => {
    const self = this;
    anketaService.getAnketaEditor(
      (data) => {
        const fields = [...data.fields];
        if (fields.length > 0) {
          self.setState({
            anketaFields: fields,
            anketaValues: data.anketa,
          });
        }
      },
      (error) => {
        self.props.dispatch(userActions.set_error(error));
        showGlobalSnackbar(responseErrorToText(error), "error");
      }
    );
  };

  getUserInfo = () => {
    let self = this;

    userService.getWrapper(
      "api/user",
      (data) => {
        let req_list = Object.values(data.data.all_requisites);
        let req_keys = Object.keys(data.data.all_requisites);

        let req_data = [];
        for (let i = 0; i < req_list.length; i++) {
          req_data[i] = { id: "", val: "" };
        }

        for (let j = 0; j < data.data.requisites.length; j++) {
          let req_id = data.data.requisites[j].requisite_key_id + "";
          let id = data.data.requisites[j].id + "";
          let val = data.data.requisites[j].value;

          let new_id = req_keys.indexOf(req_id);
          if (new_id >= 0) req_data[new_id] = { id: id, val: val };
        }

        if (this.props.user.info.type !== "student") {
          self.getTarifsList(data.data.tariff_id);
        }
        this.setState({
          req_list,
          req_data,
          req_keys,
          balance: data.data.balance,
          tariff_id: data.data.tariff_id,
          tariff_expire: data.data.tariff_expire,
          id: data.data.id,
          newsConsent: !!data.data.news_consent,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  getTarifsList = (tariff_id) => {
    userService.getWrapper(
      "api/tariff",
      (data) => {
        let tariff_info = data.data.filter((e) => e.id == tariff_id);

        if (tariff_info.length > 0)
          this.setState({
            tariff_name: tariff_info[0].name,
            tariff_actions: tariff_info[0].tariff_actions,
          });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  addMoney = () => {
    const { add_money, id } = this.state;
    let self = this;

    if (add_money <= 0) return;

    let url = `${serverUrl}replenish-balance/${id}?sum=${add_money}`;
    window.location.href = url;
  };

  getTarifInfo = () => {
    userService.getWrapper(
      "api/tariff/restriction/user",
      (data) => {
        const keys = Object.keys(data.data);
        const result =
          keys.length > 0
            ? keys.map(function (key) {
                const max = data.data[key]["max"] ?? i18next.t("unlimited");
                return (
                  <div>
                    {key}: {data.data[key]["current"] ?? 0} / {max}
                  </div>
                );
              })
            : i18next.t("unlimited");
        this.setState({ orgResriction: <div>{result}</div> });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  setReq = (index, val) => {
    let { req_data } = this.state;

    req_data[index].val = val;
    this.setState({ req_data });
  };

  onSave = () => {
    let upd_data = { requisites: [] };

    // Ключи реквизитов не обязаны идти подряд (китайская локаль получает урезанный
    // набор, QA №55) — id берём из ответа api/user, а не из позиции в списке.
    const { req_list, req_data, req_keys } = this.state;

    for (let i = 0; i < req_list.length; i++) {
      if (req_data[i].id || req_data[i].val) {
        let tmp_obj = {
          requisite_key_id: "" + req_keys[i],
          value: req_data[i].val,
          action: req_data[i].id ? "update" : "insert",
        };
        if (req_data[i].id) tmp_obj.id = req_data[i].id;

        upd_data.requisites.push(tmp_obj);
      }
    }

    userService.patchWrapperBody(
      "api/user",
      upd_data,
      (data) => {
        console.log(data);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  stateSetter = (key, value) => {
    this.setState({ [key]: value });
  };

  // Согласие на рассылку пишет та же ручка, что и в приложении-визитке
  // (см. CardApp/consents.js), а не PATCH api/user: точка записи news_consent
  // одна на весь продукт. Соглашение она подписывает заодно, но в кабинет без
  // подписанного соглашения не пускает /agreement, так что менять там нечего.
  toggleNewsConsent = (checked) => {
    const { dispatch, user } = this.props;

    this.setState({ newsConsent: checked });

    userService.postWrapper(
      "api/sign/user-agreement",
      { news_consent: checked },
      () => {
        user.info.news_consent = checked ? new Date().toISOString() : null;
        localStorage.setItem("user", JSON.stringify(user.info));
        dispatch(userActions.setuser(user.info));
        this.setState({ snackShow: true, snackText: i18next.t("changes_saved") });
      },
      // Текст ошибки показывает сам postWrapper, здесь только возвращаем галочку
      // в прежнее положение — иначе она врёт про сохранённое состояние.
      () => this.setState({ newsConsent: !checked })
    );
  };

  storeUser = (userKey, dbKey, value) => {
    const { dispatch, user } = this.props;
    userService.patchWrapperBody(
      "api/user",
      { [dbKey]: value },
      (data) => {
        user.info[userKey] = value;
        localStorage.setItem("user", JSON.stringify(user.info));
        dispatch(userActions.setuser(data.data));
      },
      (error) => {
        dispatch(userActions.set_error(i18next.t("cant_execute_request")));
      }
    );
  };

  onDrop = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length > 0) {
      const { dispatch, user } = this.props;
      const data_upload = new FormData();
      data_upload.append("avatar", acceptedFiles[0]);
      this.setState({ avatarUploading: true });
      userService.uploadFile(
        `api/user/upload`,
        data_upload,
        (data) => {
          this.setState({ avatarUploading: false });
          if (data && data.data && data.data.avatar) {
            user.info.avatar = data.data.avatar;
            localStorage.setItem("user", JSON.stringify(user.info));
            dispatch(userActions.setuser(user.info));
          } else {
            dispatch(userActions.set_error(i18next.t("cant_execute_request")));
          }
        },
        (error) => {
          this.setState({ avatarUploading: false });
          dispatch(userActions.set_error(i18next.t("cant_execute_request")));
        }
      );
    }
  };

  closeUserInfoDialog = (val) => {
    const { dispatch, user } = this.props;
    this.setState({ showInfoDialog: false });
    if (val == null) return;
    anketaService.saveAnketa(
      val,
      (data) => {
        this.setState({ snackShow: true });
        user.info.anketa = data.anketa;
        localStorage.setItem("user", JSON.stringify(user.info));
        dispatch(userActions.setuser(user.info));
        this.getVcardQr();
      },
      (error) => {
        if (error != "") {
          console.log(error);
        }
      }
    );
  };

  render() {
    const self = this;
    const { req_list, req_data, timezones, activeTab } = this.state;
    const { user } = this.props;
    const isOrg = user.info.type === "org";

    return (
      <div className="layout">
        <h1 className="layout__title" style={{ marginBottom: 10 }}>
          {i18next.t("settings")}
        </h1>
        <div className="tab-switcher">
          <ul>
            <li
              className={activeTab === 0 ? "active" : ""}
              onClick={() => this.setState({ activeTab: 0 })}
            >
              {i18next.t("profile")}
            </li>
            {isOrg && (
              <li
                className={activeTab === 1 ? "active" : ""}
                onClick={() => this.setState({ activeTab: 1 })}
              >
                {i18next.t("org_settings")}
              </li>
            )}
            {isOrg && (
              <li
                className={activeTab === 2 ? "active" : ""}
                onClick={() => this.setState({ activeTab: 2 })}
              >
                {i18next.t("finances")}
              </li>
            )}
            {isOrg && (
              <li
                className={activeTab === 3 ? "active" : ""}
                onClick={() => this.setState({ activeTab: 3 })}
              >
                {i18next.t("requisites")}
              </li>
            )}
          </ul>
        </div>

        {activeTab === 0 && (
          <div style={{ marginLeft: 10, marginTop: 10, marginBottom: 20 }}>
            <span className="form__label">{i18next.t("image")}</span>
            <DropFile onDrop={this.onDrop} image={user.info.avatar} loading={this.state.avatarUploading} />
            <Select
              value={user.info.locale}
              MenuProps={{
                anchorOrigin: { vertical: "bottom", horizontal: "right" },
                transformOrigin: { vertical: "top", horizontal: "left" },
              }}
              onChange={(e) => {
                const lang = e.target.value;
                this.storeUser("locale", "profile_locale", lang);
                i18next.init({
                  lng: lang,
                  resources: require(`../_lang/${lang}.json`),
                });
                localStorage.setItem("navic_lang", lang);
                this.props.dispatch(appActions.setlang(lang));
              }}
            >
              <MenuItem value="ru">{langLabel("ru")}</MenuItem>
              <MenuItem value="en">{langLabel("en")}</MenuItem>
              <MenuItem value="cn">{langLabel("cn")}</MenuItem>
            </Select>
            {/* Выбор часового пояса прячем там, где пояс один на всю страну:
                бэкенд в китайском режиме отдаёт единственный вариант, и селект
                с одним пунктом только сбивает с толку. Ориентируемся на ответ
                сервера, а не на флаг сборки: список задаётся его настройками. */}
            {Object.keys(timezones).length > 1 && (
              <Select
                MenuProps={{
                  anchorOrigin: { vertical: "bottom", horizontal: "right" },
                  transformOrigin: { vertical: "top", horizontal: "left" },
                }}
                value={user.info.timezone}
                onChange={(e) => {
                  this.storeUser("timezone", "timezone", e.target.value);
                }}
              >
                {Object.keys(timezones).map((item, index) => (
                  <MenuItem value={item}>{timezones[item]}</MenuItem>
                ))}
              </Select>
            )}
            <div style={{ marginTop: 16 }}>
              <Button
                onClick={() => this.setState({ showInfoDialog: true })}
                variant="contained"
              >
                {i18next.t("edit_anket")}
              </Button>
            </div>

            <div style={{ marginTop: 24, maxWidth: 480 }}>
              <span className="form__label">{i18next.t("notifications")}</span>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.newsConsent}
                    onChange={(e) => this.toggleNewsConsent(e.target.checked)}
                  />
                }
                label={i18next.t("news_consent_label")}
              />
            </div>

            {this.state.vcardQr && (
              <div style={{ marginTop: 24, maxWidth: 320 }}>
                <span className="form__label">{i18next.t("my_vcard_qr")}</span>
                <img
                  src={this.state.vcardQr}
                  alt={i18next.t("my_vcard_qr")}
                  style={{ display: "block", width: 200, height: 200 }}
                />
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    marginTop: 12,
                    flexWrap: "wrap",
                  }}
                >
                  <a
                    className="btn"
                    href={this.state.vcardQr}
                    download="contact.png"
                  >
                    {i18next.t("download_qr_png")}
                  </a>
                  <button className="btn btn--border" onClick={this.downloadVcf}>
                    {i18next.t("download_vcf")}
                  </button>
                </div>
                <div style={{ marginTop: 12, fontSize: 14 }}>
                  {i18next.t("vcard_qr_help")}
                </div>
                <div style={{ marginTop: 8, fontSize: 13, opacity: 0.7 }}>
                  {i18next.t("vcard_qr_privacy_hint")}
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 1 && isOrg && (
          <div style={{ marginTop: 10 }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Checkbox
                checked={!!user.info.multilanguage}
                onChange={(e) =>
                  this.storeUser(
                    "multilanguage",
                    "multilanguage",
                    e.target.checked ? 1 : 0
                  )
                }
              />
              <LabelHint title="multilanguage" hint="hint_multilanguage" />
            </div>
          </div>
        )}

        {activeTab === 2 && isOrg && (
          <div style={{ marginTop: 10 }}>
            <RefillBalance
              balance={this.state.balance}
              moneyToAdd={this.state.add_money}
              moneyAdder={this.addMoney}
              stateSetter={this.stateSetter}
            />
            <h3 className="layout__title">{i18next.t("tarif")}</h3>
            <div>
              {i18next.t("org_restriction")}: {this.state.orgResriction ?? ""}
            </div>
          </div>
        )}

        {activeTab === 3 && isOrg && (
          <Requisites
            req_list={req_list}
            req_data={req_data}
            setReq={this.setReq}
            onSave={this.onSave}
          />
        )}

        {process.env.REACT_APP_CHINA_MODE === "true" && (
          <div
            className="settings-legal-links link-wrapper"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: 24,
              paddingTop: 16,
              borderTop: "1px solid #e0e0e0",
              fontSize: 14,
              lineHeight: 1.5,
              overflowWrap: "anywhere",
            }}
          >
            <a
              href="https://naviconf.cn/ght-yszc.txt"
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18next.t("china_privacy_terms")}
            </a>
            <a
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: 12 }}
            >
              {i18next.t("china_app_record_number")}
            </a>
          </div>
        )}

        <UserInfoDialog
          handleClose={self.closeUserInfoDialog}
          flds={[]}
          optionalFields={this.state.anketaFields}
          values={this.state.anketaValues}
          showContactsSetting={false}
          dialogOpen={this.state.showInfoDialog}
          fullMode={true}
        />
        <Snack
          open={this.state.snackShow}
          variant={"success"}
          text={this.state.snackText}
          onClose={() => this.setState({ snackShow: false })}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user, app } = state;

  return {
    user,
    app,
  };
}

const connectedSettingsPage = connect(mapStateToProps)(SettingsPage);
export { connectedSettingsPage as SettingsPage };
